export default __webpack_public_path__ + "static/media/ic-discount.f06ad30d.svg";